module.exports = __webpack_public_path__ + "img/u5649.b4d8209a.png";